<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Property</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Enter a location" required ref="addresscomplete"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label>Or</label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Street*" required v-model="street"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="City*" required v-model="city"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Zip Code*" required v-model="zipCode"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="State*" required v-model="state"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field label="Price*" type="number" v-model="price" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Close</v-btn>
          <v-btn color="blue darken-1" text @click="addProperty">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { GetSuggestions } from '@/utils/PlaceUtils';
import { sessionService } from '../services/SessionService';
import { authService } from '@/services/AuthService';

export default {
  name: 'AddProperty',
  props: {
    show: Boolean,
    authService: authService
  },
  data() {
    return {
      locationSearchText: null,
      locationEntries: [],
      mapsInitialized: false,
      sessionService: sessionService
    };
  },
  methods: {
    addProperty: function() {
      if (this.street && this.city && this.state && this.zipCode && this.price && this.price > 0) {
        sessionService
            .addCurrentPropertyToCollection()
            .then((id) => {
              if (!authService.loggerIn) {
                this.$router.push('/properties/details/');
              } else {
                this.$router.push('/properties/details/' + id);
              }
            });
        this.$emit('saved');
      } else {
        console.log('Incomplete request');
      }
    },
    cancel: function() {
      this.$emit('cancelled');
    }
  },
  computed: {
    street: {
      get: function() {
        return sessionService.property.Address.Street;
      },
      set: function(value) {
        sessionService.property.Address.Street = value;
      }
    },
    city: {
      get: function() {
        return sessionService.property.Address.City;
      },
      set: function(value) {
        sessionService.property.Address.City = value;
      }
    },
    zipCode: {
      get: function() {
        return sessionService.property.Address.Zip;
      },
      set: function(value) {
        sessionService.property.Address.Zip = value;
      }
    },
    state: {
      get: function() {
        return sessionService.property.Address.State;
      },
      set: function(value) {
        sessionService.property.Address.State = value;
      }
    },
    price: {
      get: function() {
        if (sessionService.property.Price) {
          return sessionService.property.Price;
        } else {
          return 0;
        }
      },
      set: function(value) {
        sessionService.property.Price = value;
      }
    }
  },
  watch: {
    locationSearchText(newVal) {
      let _vue = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 1) return;

      // Call the method from the previous section here
      GetSuggestions(newVal)
          .then(function(res) {
            _vue.locationEntries = res;
          })
          .catch(function(err) {
            console.log(err);
          });
    },
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const google = window.google;
          this.autocomplete = new google.maps.places.Autocomplete(
              (this.$refs.addresscomplete.$refs.input), {}
          );

          this.autocomplete.addListener('place_changed', () => {
            let place = this.autocomplete.getPlace();
            let components = place.address_components;
            let streetNumber = null;
            let street = null;
            components.forEach(component => {
              if (component.types[0] === 'street_number') {
                streetNumber = component['long_name'];
              } else if (component.types[0] === 'route') {
                street = component['long_name'];
              } else if (component.types[0] === 'postal_code') {
                sessionService.property.Address.Zip = component['short_name'];
              } else if (component.types[0] === 'locality') {
                sessionService.property.Address.City = component['long_name'];
              } else if (component.types[0] === 'administrative_area_level_1') {
                sessionService.property.Address.State = component['short_name'];
              }
            });
            sessionService.property.Address.Street = `${streetNumber} ${street}`;
          });
        });
      }
    }
  }
};
</script>

<style scoped>

</style>